<template>
<v-row wrap>
    <v-responsive class="overflow-y-auto" style="padding:0px;" max-height="80vh">

        <v-col cols="12">
            <v-row wrap>
                <v-col cols="4">
                    <v-row wrap>
                        <v-col style="padding:8px" cols="12" justify="center">
                            <v-card height="13vh" class="text-center box-card">
                                <p class="subtitle " style="padding-top:1vh">{{data.menu[data.language]['dashboard']['unavailable']}}</p>
                                <p class="headline">{{data.room_close}}</p>
                            </v-card>
                        </v-col>
                        <v-col style="padding:8px" cols="12" justify="center">
                            <v-card height="13vh" class="text-center box-card">
                                <p class="subtitle" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['available']}}</p>
                                <p class="headline">{{data.room_ready}} </p>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <v-row wrap>
                        <v-col style="padding:8px" cols="12" justify="center">
                            <v-card height="13vh" class="text-center box-card">
                                <p class="subtitle" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['user']}}</p>
                                <p class="headline">{{data.count_user}} </p>
                            </v-card>
                        </v-col>
                        <v-col style="padding:8px" cols="12" justify="center">
                            <v-card height="13vh" class="text-center box-card">
                                <p class="subtitle" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['booking']}}</p>
                                <p class="headline">{{data.count_booking}} </p>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <v-row wrap>
                        <v-col style="padding:8px" cols="12" justify="center">
                            <v-card height="28vh" class="text-center box-card">
                                <p class="subtitle" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['usage_per_room']}}</p>
                                <p v-if="data.chart_booking_data[0] != null">
                                    <apexchart style="padding-left:7vh" type="pie" width="70%" :options="chartOptions_1" :series="data.chart_booking_data"></apexchart>
                                </p>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>

        <v-row justify="center">
            <v-col cols="12" style="padding-top:2vh">
                <v-card color='#28304C' class="text-center box-card">
                    <p class="title white--text" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['meeting_room_used']}}</p>
                    <p v-if="data.chart_booking_day_data[0].data[0] != null">
                        <apexchart dark height="200" :options="chartOptions" :series="data.chart_booking_day_data"></apexchart>
                    </p>
                </v-card>
            </v-col>

        </v-row>
        <v-row justify="center">
            <v-col cols="12" style="padding-top:1vh">
                <v-card color='#28304C' class="text-center box-card">
                    <p class="title white--text" style="padding-top:1vh">{{data.menu[data.language]['dashboard']['reserving_time']}}</p>
                    <p v-if="data.chart_booking_time[0].data[0] != null">
                        <apexchart dark height="200" :options="chartOptions_2" :series="data.chart_booking_time"></apexchart>
                    </p>
                </v-card>
            </v-col>

        </v-row>
    </v-responsive>
</v-row>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data: function () {
        return {

            series_1: [44, 55],
            chartOptions_1: {
                chart: {
                    id: 'roomchart',
                    width: 380,
                    type: 'pie',
                },
                // labels: ['linkroom001', 'linkroom002'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                legend: {
                    show: false,
                    floating: true,
                    fontSize: '16px',
                    position: 'left',
                    offsetX: 0,
                    // offsetY: 100,
                    labels: {
                        useSeriesColors: true,
                    },
                    markers: {
                        size: 20
                    },
                    itemMargin: {
                        vertical: 3
                    }
                },
                colors: ['#757575', '#2E4884']
            },

            test: [3, 4, 3, 7, 0, 0, 0],
            chartOptions: {
                chart: {
                    id: 'chart1',
                    type: 'bar',
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                title: {
                    text: 'ชั่วโมง',
                    style: {
                        color: '#ffffff',
                    }
                },

                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '5%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false,
                    style: {
                        fontSize: '12px',
                        // colors: ['#ffffff']
                    }
                },
                colors: ['#ffffff'],

                xaxis: {
                    labels: {
                        show: true,
                        style: {
                            colors: ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
                        }
                    },
                    categories: [],

                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#ffffff'
                        }
                    }
                }

            },

            series: [{
                "name": "ครั้ง",
                "data": [3, 4, 3, 7, 0, 0, 0]
            }],

            chartOptions_2: {
                chart: {
                    type: 'line',
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                title: {
                    text: 'ชั่วโมง',
                    style: {
                        color: '#ffffff',
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        gradientToColors: ['#EEEEEE'],
                        shadeIntensity: 1,
                        type: 'horizontal',
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100, 100, 100]
                    },
                },
                markers: {
                    size: 4,
                    colors: ["#ffffff"],
                    strokeColors: "#fff",
                    strokeWidth: 2,
                    hover: {
                        size: 7,
                    }
                },

                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '5%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false,
                    style: {
                        fontSize: '12px',
                        // colors: ['#ffffff']
                    }
                },
                colors: ['#ffffff'],

                xaxis: {
                    labels: {
                        show: true,
                        style: {
                            colors: ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
                        }
                    },
                    // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
                    categories: ['7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'],

                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#ffffff'
                        }
                    }
                }

            },
        }

    },

    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
        name() {
            return this.$store.state.datas.data.chart_booking_day_name
        }
    },
    created() {
        this.$store.dispatch("datas/getdashboard")
    },
    methods: {
        update() {
            ApexCharts.exec('chart1', 'updateOptions', {
                xaxis: {

                    categories: this.$store.state.datas.data.chart_booking_day_name

                }
            }, );
        }

    },
    watch: {
        name() {

            setTimeout(() => {

                ApexCharts.exec('chart1', 'updateOptions', {
                        xaxis: {

                            categories: this.$store.state.datas.data.chart_booking_day_name

                        }
                    },

                );

                ApexCharts.exec('roomchart', 'updateOptions', {
                    // xaxis: {

                    //     categories: this.$store.state.datas.data.chart_booking_day_name

                    // }
                    labels: this.$store.state.datas.data.chart_booking_name
                })

            }, 2000);

        }
    },

}
</script>

<style lang="scss" scoped>
.box {
    border-radius: 30px;
}

.box-card {
    border-radius: 12px;
}
</style>
